import { createTheme } from "@mui/material";

const muiTheme = createTheme({
  typography: {
    body1: {
      fontFamily: "Urbanist,sans-serif",
      color: "var(--Dark, #1E232C)",
    },
    subtitle1: {
      fontFamily: "Urbanist,sans-serif",
      fontWeight: "500",
      color: "#1E232C",
      fontSize: "16.912px",
      fontStyle: "normal",
      lineHeight: "normal",
    },

    subtitle2: {
      fontFamily: "Urbanist,sans-serif",
      fontWeight: 500,
      color: "#939598",
      fontSize: "14.657px",
      fontStyle: "normal",
      lineHeight: "normal",
    },

    h5: {
      fontFamily: "Urbanist,sans-serif",
      color: "#fff",
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "normal",
    },

    h6: {
      fontFamily: "Urbanist,sans-serif",
      color: "#000",
      fontSize: "24.67px",
      fontWeight: 500,
      lineHeight: "normal",
    },
    subtitle3: {
      fontFamily: "Urbanist,sans-serif",
      fontWeight: "400",
      color: "#535964",
      fontSize: "17.86px",
      fontStyle: "normal",
      lineHeight: "normal",
    },

    // button: {
    //   background:
    //     "var(--Grad, linear-gradient(96deg, #DA5332 -5.2%, #DA5332 -5.19%, #F78524 113.53%))",
    // },
    // primary: {
    //   color:
    //     "var(--Grad, linear-gradient(96deg, #DA5332 -5.2%, #DA5332 -5.19%, #F78524 113.53%))",
    // },
  },
});

export default muiTheme;
